import React, { useState } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { apiClient } from "@/lib/apiClient";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function ResetPassword() {
  const [searchParams] = useSearchParams();
  const initialToken = searchParams.get("token") || "";
  const [token, setToken] = useState(initialToken);
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setMessage("");
    if (!token) {
      setError("Token fehlt.");
      return;
    }
    if (password !== password2) {
      setError("Passwörter stimmen nicht überein.");
      return;
    }
    setLoading(true);
    try {
      const res = await apiClient.post("/auth/reset-password", {
        token,
        new_password: password,
      });
      setMessage(res.data?.message || "Passwort wurde zurückgesetzt.");
      // Nach kurzer Zeit zurück zum Login
      setTimeout(() => navigate("/login"), 1500);
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.detail || "Reset fehlgeschlagen.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="reset-password-page">
      <Card className="w-full max-w-md p-6 border border-slate-200 shadow-sm bg-white">
        <h1 className="text-2xl font-semibold text-slate-900 mb-2">Passwort zurücksetzen</h1>
        <p className="text-sm text-slate-500 mb-4">
          Geben Sie den Reset-Token und Ihr neues Passwort ein.
        </p>

        {message && (
          <div className="mb-3 rounded-md border border-emerald-200 bg-emerald-50 px-3 py-2 text-xs text-emerald-800">
            {message}
          </div>
        )}
        {error && (
          <div className="mb-3 rounded-md border border-rose-200 bg-rose-50 px-3 py-2 text-xs text-rose-800">
            {error}
          </div>
        )}

        <form className="space-y-3" onSubmit={handleSubmit} data-testid="reset-password-form">
          <div className="space-y-1">
            <Label htmlFor="token">Token</Label>
            <Input
              id="token"
              type="text"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              data-testid="reset-password-token-input"
            />
          </div>
          <div className="space-y-1">
            <Label htmlFor="password">Neues Passwort</Label>
            <Input
              id="password"
              type="password"
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="reset-password-password-input"
            />
          </div>
          <div className="space-y-1">
            <Label htmlFor="password2">Neues Passwort wiederholen</Label>
            <Input
              id="password2"
              type="password"
              autoComplete="new-password"
              value={password2}
              onChange={(e) => setPassword2(e.target.value)}
              data-testid="reset-password-password2-input"
            />
          </div>
          <div className="flex justify-between items-center text-xs text-slate-500">
            <Link to="/login" className="hover:underline" data-testid="reset-password-back-to-login-link">
              Zurück zur Anmeldung
            </Link>
          </div>
          <div className="flex justify-end">
            <Button
              type="submit"
              size="sm"
              className="rounded-full bg-slate-900 text-slate-50 px-4"
              disabled={loading}
              data-testid="reset-password-submit-button"
            >
              {loading ? "Setze Passwort ..." : "Passwort setzen"}
            </Button>
          </div>
        </form>
      </Card>
    </div>
  );
}
